import React, { useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Html5Qrcode } from "html5-qrcode";
import { toast } from "sonner";

export function BarcodeScanner({ open, onClose, onScan }) {
  const ref = useRef(null);
  const scannerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    let active = true;
    const id = "billone-scanner-region";
    const start = async () => {
      try {
        const scanner = new Html5Qrcode(id);
        scannerRef.current = scanner;
        await scanner.start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 250, height: 160 } },
          (decoded) => { if (active) { onScan(decoded); stop(); } }, () => {});
      } catch (e) { toast.error("Camera access failed. Use a USB scanner or search instead."); onClose(); }
    };
    const stop = async () => {
      active = false;
      try { if (scannerRef.current) { await scannerRef.current.stop(); scannerRef.current.clear(); } } catch {}
    };
    const t = setTimeout(start, 200);
    return () => { clearTimeout(t); stop(); };
  }, [open, onScan, onClose]);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-white max-w-sm">
        <DialogHeader><DialogTitle className="font-display text-[#1A2A5E]">Scan Barcode</DialogTitle></DialogHeader>
        <div id="billone-scanner-region" ref={ref} className="w-full rounded-lg overflow-hidden bg-black min-h-[240px]" data-testid="barcode-scanner-region" />
        <p className="text-xs text-slate-400 text-center">Point the camera at a product barcode</p>
      </DialogContent>
    </Dialog>
  );
}
